/**
 * User Information (Mettre les infos de l'utilisateur dans ce state peut importe le système d'authentification)
 */
const userInfo = {
  strict: true,
  namespaced: true,
  state: {
    info: {
      name: '',
      firstName: '',
      displayName: '',
      username: '',
      usernameVerification: '',
      email: '',
      roles: [],
    },
    imageProfile: null,
    newCardContratId: null,
  },

  getters: {
    getImageProfil (state) {
      return state.imageProfile
    },
  },

  mutations: {
    updateUser (state, payload) {
      state.info = payload
    },
    resetUser (state) {
      state.info = {
        name: '',
        firstName: '',
        displayName: '',
        username: '',
        usernameVerification: '',
        email: '',
        roles: [],
      }

      state.imageProfile = null
    },
    updateImageProfil (state, payload) {
      state.imageProfile = payload
    },
    updateNewCard (state, payload) {
      state.newCardContratId = payload
    },
    resetNewCard (state) {
      state.newCardContratId = null
    },
  },
}

export default userInfo
